namespace Nobox {
    export interface MembershipPageModel {
        OrderHistory?: Nobox.Web.Modules.Administration.Tenant.Berlangganan[];
        Quota?: Quota[];
        ListChannel?: ListChannel[];
        totalSizeNm?: string;
        totalSizeDisk?: string;
        avaibleDiskPercentage?: string;
        stroageLimit?: boolean;
        Support?: string;
        Member?: number;
        Account?: number;
    }
}
